export default __webpack_public_path__ + "static/media/gaming_Footer_Lottoland_Supplier.b56f9888.svg";